import {AbstractControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged, skip, startWith} from 'rxjs/operators';
import {Utilities} from '@core/helpers/utilities';
import {perListenerSession} from './listener-session';

/**
 * Debounced change-only operator for form listeners.
 *
 * Does not emit the initial value.
 * The current control value is used only to seed distinctUntilChanged,
 * then the seeded emission is skipped.
 *
 * This is useful for InfoPath-like OnAfterChange/ruleSetAction listeners:
 * they should react only to real changes, not to form population or document load.
 *
 * Especially useful for side-effect listeners that clear dependent fields, show toasts,
 * patch other controls or trigger warning logic.
 *
 * @param control Control used to seed distinctUntilChanged with its current value.
 * @param debounceMs Debounce duration in milliseconds.
 */
export function withChangeDebounced(control: AbstractControl, debounceMs = Utilities.LISTENERS_DEBOUNCE_TIME) {
    return perListenerSession((s$) => s$.pipe(startWith(control.value), distinctUntilChanged(), skip(1), debounceTime(debounceMs)));
}
